export default function createWatermark(text) {
    require('styles/components/_watermark.scss');
    const watermark = document.createElement('div');
    watermark.innerHTML = text.toUpperCase();
    watermark.classList.add('watermark');
    watermark.classList.add(text);
    document.body.appendChild(watermark);
}
